import React, { FC } from 'react';
import { TpayButton } from './Tpay.styled';

type TpayProps = {
    onClick: () => void;
    isLoading?: boolean;
};

export const Tpay: FC<TpayProps> = ({ onClick, isLoading }) => {
    return <TpayButton isLoading={isLoading} onClick={onClick}>Оплатить с T‑Pay</TpayButton>;
};
